import { useQuery } from 'react-query';
import api from 'services';
import type { IndependentIraUsersMetricsResponse } from 'services/requests';
import type { ApiError } from 'services/api.errors';
import { useQueryFilters } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import type { AxiosError } from 'axios';

export const useGetIndependentIraUsersMetrics = () => {
  const {
    status,
    userProfileType,
    custodianType,
    displaySepIra,
    onlyFunded,
    accountClosed,
    search,
  } = useQueryFilters();

  const params = {
    ...(status ? { status } : {}),
    ...(userProfileType ? { userProfileType } : {}),
    ...(custodianType ? { custodianType } : {}),
    ...(displaySepIra ? { displaySepIra } : {}),
    ...(onlyFunded ? { onlyFunded } : {}),
    ...(accountClosed ? { accountClosed } : {}),
    ...(search ? { search } : {}),
  };

  const queryKey = [
    QueryKeys.independentIraUsersMetrics,
    status,
    userProfileType,
    custodianType,
    displaySepIra,
    onlyFunded,
    accountClosed,
    search,
  ];

  const queryFn = async () => {
    const { data } = await api.getIndependentIraUsersMetrics(params);
    return data;
  };

  return useQuery<IndependentIraUsersMetricsResponse, AxiosError<ApiError>>(
    queryKey,
    queryFn,
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 600000, // 10 mins
      cacheTime: 3600000, // 1 hour
    },
  );
};
